export default ({ store, redirect }) => {
  return store.dispatch('auth/whoami').catch(e => {
    store.commit('auth/removeCurrentUser')
  })
}
